
import { defineComponent } from "vue";
import { nameValidation, validateLinkLattes } from "@/utils/validations";
import api from "@/services/api";
import EducationOption from "@/types/education";
import BaobahUser from "@/types/baobahuser";
import { mapActions } from "vuex";
import store from "@/store";

export default defineComponent({
  data() {
    return {
      fullName: "",
      lattesLink: "",
      educationLevel: null,
      educationOptions: [] as { id: number; name: string }[], // Dados do select escolaridade

      fullNameError: "",
      lattesLinkError: "",
      snackbar: {
        message: "",
        color: "",
        show: false,
      },
    };
  },
  methods: {
    async fetchEducationOptions() {
      try {
        const response = await api.get("education/?limit=20");
        if (response.status === 200) {
          this.educationOptions = response.data.filter(
            (option: EducationOption) => option.is_active
          );
        }
      } catch (error) {
        console.error("Erro ao carregar opções de escolaridade:", error);
      }
    },
    validateFullName() {
      const validation = nameValidation(this.fullName);
      this.fullNameError = validation === true ? "" : validation;
    },
    validateLattesLink() {
      const validation = validateLinkLattes(this.lattesLink);
      this.lattesLinkError = validation === true ? "" : validation;
    },

    async handleSubmit() {
      // Valida todos os campos antes de enviar
      this.validateFullName();
      this.validateLattesLink();

      if (!this.fullNameError && !this.lattesLinkError) {
        // Criar o payload utilizando a interface
        const meuuser = store.getters.getUserId;
        const userPayload: BaobahUser = {
          name: this.fullName,
          lattes_url: this.lattesLink || null,
          education: this.educationLevel ?? "",
          user: meuuser,
          avatar: null,
          biography: "",
          is_active: true,
          has_reviewer_request: false,
        };

        try {
          const response = await api.post("users/create", userPayload);

          if (response.status === 201) {
            this.snackbar.message = "Perfil cadastrado com sucesso!";
            this.snackbar.color = "success";
            this.snackbar.show = true;
            store.commit("setBaoBahUser", response.data);
            setTimeout(() => {
              this.$router.push("/"); // Redireciona para a página inicial
            }, 2000);
          } else {
            this.snackbar.message = "Falha no cadastro de perfil.";
            this.snackbar.color = "error";
            this.snackbar.show = true;
          }
        } catch (error) {
          this.snackbar.message = "Erro no cadastro: " + error;
          this.snackbar.color = "error";
          this.snackbar.show = true;
        }
      }
    },
  },
  mounted() {
    this.fetchEducationOptions();
  },
});
